import { CheckCircle, HandCoins, Hourglass, Settings } from "lucide-react";
import { usePostHog } from "posthog-js/react";
import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useUser } from "#/contexts/UserContext";
import { useFlashMessages } from "#/pages/Layout";

import { Layout } from "../(components)/Layout";

export default function SingupPage() {
  const { user } = useUser();

  if (user.id) {
    return <Navigate to="/admin/theses" />;
  }
  const location = useLocation();
  const posthog = usePostHog();

  React.useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  useFlashMessages();

  return (
    <Layout>
      <div className="relative h-full flex justify-center flex-col z-50">
        <div className="flex-col flex gap-y-2 text-muted font-semibold md:text-3xl xl:text-4xl">
          <span>Feito por tributaristas,</span>
          <span>para tributaristas.</span>
        </div>

        <div className="grid grid-cols-2 gap-x-4 gap-y-6 mt-10 text-muted">
          <FeatureCard Icon={Hourglass}>
            Faça, em poucos <span className="font-semibold">minutos</span>,
            aquilo que você demoraria dias para fazer.
          </FeatureCard>
          <FeatureCard Icon={HandCoins}>
            Multiplique a{" "}
            <span className="font-semibold">geração de negócios</span> da área
            tributária do seu escritório.
          </FeatureCard>
          <FeatureCard Icon={CheckCircle}>
            Dê mais{" "}
            <span className="font-semibold">
              autonomia, segurança e assertividade
            </span>{" "}
            para a sua equipe.
          </FeatureCard>
          <FeatureCard Icon={Settings}>
            Automatize processos manuais e{" "}
            <span className="font-semibold">ganhe tempo</span> na sua agenda.
          </FeatureCard>
        </div>
      </div>
    </Layout>
  );
}

function FeatureCard({ Icon, children }) {
  return (
    <div className="bg-primary brightness-110 rounded-xl py-4 px-3 flex flex-col items-center gap-y-2">
      <Icon size={24} />
      <span className="text-center text-sm font-light">{children}</span>
    </div>
  );
}
